import { useEffect, useState } from "react";
import classes from "../../src/Style/Settings.module.css";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  styled,
  LinearProgress,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Autocomplete,
  Box,
  InputAdornment,
} from "@mui/material";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { useFetch } from "../hooks/useFetch";
import Wrapper from "../Components/Wrapper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { FormDialog } from "../Components/FormDialog";
import { countries } from "./Business";

export default function Settings() {
  const { Fetch } = useFetch();

  const [data, setData] = useState([]);
  const [loading, setloading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [userData, setUserData] = useState({});
  const [createEnabled, setCreateEnabled] = useState(false);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);

  const loggedInAdmin = JSON.parse(
    window.sessionStorage.getItem("loggedInAdmin"),
  );

  async function Load_data() {
    setloading(true);

    let res = await Fetch("get", "admins");
    setData(res);

    setloading(false);
  }

  const createAccount = async () => {
    setloading(true);
    let res = await Fetch("post", "admins", userData);

    setUserData({});
    setShowForm(false);

    setloading(false);

    Load_data();
  };

  useEffect(() => {
    Load_data();
  }, []);

  useEffect(() => {
    const isComplete =
      userData.name &&
      userData.surname &&
      userData.countryCode &&
      userData.mobileNumber &&
      userData.email &&
      userData.password &&
      userData.confirmPassword &&
      userData.role;
    const isValidEmail = /^\S+@\S+\.\S+$/.test(userData.email || "");
    const passwordsMatch = userData.password === userData.confirmPassword;
    const isValidPhone = /^\+?\d[\d\s]{6,19}$/.test(
      userData.mobileNumber || "",
    );
    setCreateEnabled(
      isComplete && isValidEmail && passwordsMatch && isValidPhone,
    );
  }, [userData]);

  return (
    <Wrapper bodyFullHeight>
      <section className={classes.BodySection}>
        <div className={classes.DataTableHeader}>
          <h2 className={classes.comptitile}>Settings</h2>
          <AddCircleIcon
            className={classes.add_button}
            fontSize="large"
            onClick={() => setShowForm(true)}
          />
        </div>
        <div className={classes.DataTable}>
          <DataGrid
            columns={[
              {
                field: "email",
                flex: 0.3,
                headerName: "E-mail",
              },
              {
                field: "fullname",
                headerName: "Name",
                flex: 0.2,
                renderCell: (row) => row.row.name + " " + row.row.surname,
              },
              {
                field: "last_login",
                headerName: "Last Login",
                flex: 0.2,
              },

              {
                field: "active",
                flex: 0.1,
                headerName: "Status",
                renderCell: (row) =>
                  loggedInAdmin.role === "A" ? (
                    row.value ? (
                      <span style={{ color: "#2D90EC" }}>Active</span>
                    ) : (
                      <span style={{ color: "#747474" }}>Not Active</span>
                    )
                  ) : loggedInAdmin.role === "S" ? (
                    row.value ? (
                      <DeactivateButton
                        size="small"
                        variant="outlined"
                        className={classes.btn}
                        color="error"
                        onClick={() => deactivate_button(row.row.id)}
                        disabled={loggedInAdmin.role != "S"}
                      >
                        Deactivate
                      </DeactivateButton>
                    ) : (
                      <ActivateButton
                        size="small"
                        variant="outlined"
                        disabled={!row.value == "S"}
                        onClick={() => activate_button(row.row.id)}
                      >
                        Activate
                      </ActivateButton>
                    )
                  ) : (
                    ""
                  ),
              },
              {
                field: "role",
                flex: 0.1,
                headerName: "Role",
                renderCell: (row) =>
                  row.value == "S" ? (
                    <span style={{ color: "#0B3758" }}>Super Admin</span>
                  ) : (
                    <span style={{ color: "#0B3758" }}> Admin</span>
                  ),
              },
            ]}
            rows={data}
            loading={loading}
            components={{
              LoadingOverlay: LinearProgress,
            }}
          ></DataGrid>
        </div>
      </section>
      <FormDialog
        show={showForm}
        onClose={() => {
          setShowForm(false);
        }}
        hideDialogActions
        dialogTitle="Add new account"
      >
        <div className={classes.dialogContainer}>
          <TextField
            label="Name"
            className={classes.textField}
            value={userData.name || ""}
            required
            onChange={(e) =>
              setUserData({ ...userData, name: e.target.value.trim() })
            }
          />
          <TextField
            label="Surname"
            className={classes.textField}
            value={userData.surname || ""}
            required
            onChange={(e) =>
              setUserData({ ...userData, surname: e.target.value.trim() })
            }
          />
          <Autocomplete
            id="country-select-demo"
            className={classes.textField}
            sx={{}}
            options={countries}
            autoHighlight
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            getOptionLabel={(option) => option.label}
            onChange={(_, value) =>
              setUserData({ ...userData, countryCode: value ? value.code : "" })
            }
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                <img
                  loading="lazy"
                  width="20"
                  src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                  srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                  alt=""
                />
                {option.label} ({option.code}) +{option.phone}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                value={userData.countryCode || ""}
                {...params}
                label="Country Code"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password", // disable autocomplete and autofill
                }}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: value ? (
                    <InputAdornment
                      position="start"
                      onClick={() => setOpen(true)}
                    >
                      <img
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${value.code.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${value.code.toLowerCase()}.png 2x`}
                        alt=""
                      />
                    </InputAdornment>
                  ) : null,
                }}
              />
            )}
          />
          <TextField
            label="Mobile Number"
            className={classes.textField}
            value={userData.mobileNumber || ""}
            required
            onChange={(e) =>
              setUserData({ ...userData, mobileNumber: e.target.value.trim() })
            }
          />
          <TextField
            label="Email"
            className={classes.textField}
            value={userData.email || ""}
            required
            onChange={(e) =>
              setUserData({ ...userData, email: e.target.value.trim() })
            }
          />
          <TextField
            label="Password"
            className={classes.textField}
            type="password"
            value={userData.password || ""}
            required
            onChange={(e) =>
              setUserData({ ...userData, password: e.target.value })
            }
          />
          <TextField
            label="Confirm Password"
            className={classes.textField}
            type="password"
            value={userData.confirmPassword || ""}
            required
            onChange={(e) =>
              setUserData({ ...userData, confirmPassword: e.target.value })
            }
          />
          <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
            <InputLabel id="role-select">Role *</InputLabel>
            <Select
              labelId="role-select"
              value={userData.role || ""}
              onChange={(e) =>
                setUserData({ ...userData, role: e.target.value })
              }
            >
              <MenuItem value={"A"}>Admin</MenuItem>
              <MenuItem value={"S"}>Super Admin</MenuItem>
            </Select>
          </div>
          <Button
            variant="contained"
            style={{ height: "max-content" }}
            loading={true}
            onClick={createAccount}
            disabled={!createEnabled || loading}
          >
            Create
          </Button>
        </div>
      </FormDialog>
    </Wrapper>
  );

  function deactivate_button(id) {
    confirmAlert({
      title: "Confirm to Deactivate user",
      message: "Are you sure that you want to de-activate this user ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => userActivation(id, false),
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }

  function activate_button(id) {
    confirmAlert({
      title: "Confirm to Activate user",
      message: "Are you sure that you want to activate this user ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => userActivation(id, true),
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }

  async function userActivation(id, active) {
    await Fetch("post", "admins_status", {
      active: active,
      adminID: id,
    });
    Load_data();
  }
}

const DeactivateButton = styled(Button)({
  color: "#FF4C4C",
  fontSize: 12,
  padding: "6px 12px",
  border: "1px solid #FFC4C4",
  boxSizing: "border-box",
  borderRadius: 10,
  lineHeight: 1.5,
  backgroundColor: "#fff",
  "&:hover": {
    backgroundColor: "#fff",
    border: "1px solid #FFC4C4",
  },
});

const ActivateButton = styled(Button)({
  color: "#64c4b6",
  fontSize: 12,
  padding: "6px 12px",
  border: "1px solid #64c4b6",
  boxSizing: "border-box",
  borderRadius: 10,
  lineHeight: 1.5,
  backgroundColor: "#fff",
  "&:hover": {
    backgroundColor: "#fff",
    border: "1px solid #64c4b6",
  },
});
